export { default as PetCard } from "./PetCard";
